import { gql } from 'graphql-request';
import { Customer } from 'src/shared/types';

export const createCustomerMutation = gql`
    mutation admin($customerId: String!, $customerName: String!) {
        admin {
            createCustomer(customerId: $customerId, customerName: $customerName) {
                customerId
                customerName
                customerCode
            }
        }
    }
`;

export type CreateCustomerParams = {
    customerId: string;
    customerName: string;
};

export type CreateCustomerResult = {
    admin: {
        createCustomer: Pick<Customer, 'customerId' | 'customerName' | 'customerCode'>;
    };
};

export const updateCustomerMutation = gql`
    mutation admin($customerId: String!, $customerName: String!) {
        admin {
            updateCustomer(customerId: $customerId, customerName: $customerName) {
                customerId
                customerName
            }
        }
    }
`;

export type UpdateCustomerParams = {
    customerId: string;
    customerName: string;
};

export type UpdateCustomerResult = {
    admin: {
        updateCustomer: Pick<Customer, 'customerId' | 'customerName'>;
    };
};
